import { validateSessionByCookie } from '../../services/cookies';
import { AddToCartDto } from './add_to_cart.dto';

export const handleAddToCartEvent = (data: AddToCartDto) => {
  const event = {
    event: data.event ?? 'add_to_cart',
    event_params: {
      page_path: data.page_path,
      micrositio: data.micrositio ?? 'booking',
      page_type: data.page_type,
      homemarket: data.homemarket ?? 'chile',
      negocio: data.negocio ?? 'retail',
      buy_instance: data.buy_instance ?? 'IS',
      environment: data.environment ?? 'production',
      login: validateSessionByCookie(),
      corp: data.corp ?? false,
      app: data.app ?? false,
      initial_date: data.initial_date,
      end_date: data.end_date,
      from_iata: data.from_iata,
      to_iata: data.to_iata,
      trip_type: data.trip_type,
      passengers_adult: data.passengers_adult,
      passengers_child: data.passengers_child,
      passengers_infant: data.passengers_infant,
      passengers_pet: data.passengers_pet,
      pax: data.pax,
      full_trip: data.full_trip,
      time: data.time,
      exchange_rate: data.exchange_rate,
      fare_basis: data.fare_basis,
      ecommerce: data.ecommerce,
      ...(data.bundle && { bundle: data.bundle }),
    },
    user_properties: {
      pass_dni_hashed: data.pass_dni_hashed ?? null,
      birthday: data.birthday ?? null,
    },
  };

  return event;
};
